import { Component, computed, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IecSchedulingData } from '../../model/iec-scheduling-data';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-scheduling-data-dialog',
  imports: [MatButton],
  templateUrl: './scheduling-data-dialog.component.html',
  styleUrl: './scheduling-data-dialog.component.css',
})
export class SchedulingDataDialogComponent {
  private dialogRef = inject<MatDialogRef<SchedulingDataDialogComponent>>(MatDialogRef);
  private readonly data = inject<IecSchedulingData>(MAT_DIALOG_DATA);
  readonly entityId = computed(() => this.data?.entityId ?? '');
  readonly schedulingComments = computed(() => this.data?.schedulingComments ?? '');
  readonly purchasingComments = computed(() => this.data?.purchasingComments ?? '');

  close(): void {
    this.dialogRef.close();
  }
}
